// Fetch users with management details
export const USER_MANAGEMENT_FETCH_USERS = 'USER_MANAGEMENT_FETCH_USERS';
export const USER_MANAGEMENT_FETCH_USERS_SUCCESS = 'USER_MANAGEMENT_FETCH_USERS_SUCCESS';
export const USER_MANAGEMENT_FETCH_USERS_ERROR = 'USER_MANAGEMENT_FETCH_USERS_ERROR';

// Fetch single user details
export const USER_MANAGEMENT_FETCH_USER_DETAILS = 'USER_MANAGEMENT_FETCH_USER_DETAILS';
export const USER_MANAGEMENT_FETCH_USER_DETAILS_SUCCESS = 'USER_MANAGEMENT_FETCH_USER_DETAILS_SUCCESS';
export const USER_MANAGEMENT_FETCH_USER_DETAILS_ERROR = 'USER_MANAGEMENT_FETCH_USER_DETAILS_ERROR';

// Reset password
export const USER_MANAGEMENT_RESET_PASSWORD = 'USER_MANAGEMENT_RESET_PASSWORD';
export const USER_MANAGEMENT_RESET_PASSWORD_SUCCESS = 'USER_MANAGEMENT_RESET_PASSWORD_SUCCESS';
export const USER_MANAGEMENT_RESET_PASSWORD_ERROR = 'USER_MANAGEMENT_RESET_PASSWORD_ERROR';

// Set password
export const USER_MANAGEMENT_SET_PASSWORD = 'USER_MANAGEMENT_SET_PASSWORD';
export const USER_MANAGEMENT_SET_PASSWORD_SUCCESS = 'USER_MANAGEMENT_SET_PASSWORD_SUCCESS';
export const USER_MANAGEMENT_SET_PASSWORD_ERROR = 'USER_MANAGEMENT_SET_PASSWORD_ERROR';

// Fetch user representatives
export const USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES = 'USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES';
export const USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES_SUCCESS = 'USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES_SUCCESS';
export const USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES_ERROR = 'USER_MANAGEMENT_FETCH_USER_REPRESENTATIVES_ERROR';

// Fetch user powers
export const USER_MANAGEMENT_FETCH_USER_POWERS = 'USER_MANAGEMENT_FETCH_USER_POWERS';
export const USER_MANAGEMENT_FETCH_USER_POWERS_SUCCESS = 'USER_MANAGEMENT_FETCH_USER_POWERS_SUCCESS';
export const USER_MANAGEMENT_FETCH_USER_POWERS_ERROR = 'USER_MANAGEMENT_FETCH_USER_POWERS_ERROR';

// Update search and filters
export const USER_MANAGEMENT_SET_SEARCH = 'USER_MANAGEMENT_SET_SEARCH';
export const USER_MANAGEMENT_SET_FILTERS = 'USER_MANAGEMENT_SET_FILTERS';
export const USER_MANAGEMENT_SET_PAGINATION = 'USER_MANAGEMENT_SET_PAGINATION';

// Legacy actions (keeping for compatibility)
export const USER_MANAGEMENT_CREATE_USER = 'USER_MANAGEMENT_CREATE_USER';
export const USER_MANAGEMENT_CREATE_USER_SUCCESS = 'USER_MANAGEMENT_CREATE_USER_SUCCESS';
export const USER_MANAGEMENT_CREATE_USER_ERROR = 'USER_MANAGEMENT_CREATE_USER_ERROR';

export const USER_MANAGEMENT_UPDATE_USER = 'USER_MANAGEMENT_UPDATE_USER';
export const USER_MANAGEMENT_UPDATE_USER_SUCCESS = 'USER_MANAGEMENT_UPDATE_USER_SUCCESS';
export const USER_MANAGEMENT_UPDATE_USER_ERROR = 'USER_MANAGEMENT_UPDATE_USER_ERROR';

export const USER_MANAGEMENT_DELETE_USER = 'USER_MANAGEMENT_DELETE_USER';
export const USER_MANAGEMENT_DELETE_USER_SUCCESS = 'USER_MANAGEMENT_DELETE_USER_SUCCESS';
export const USER_MANAGEMENT_DELETE_USER_ERROR = 'USER_MANAGEMENT_DELETE_USER_ERROR';

// Update user representatives
export const USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES = 'USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES';
export const USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES_SUCCESS = 'USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES_SUCCESS';
export const USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES_ERROR = 'USER_MANAGEMENT_UPDATE_USER_REPRESENTATIVES_ERROR';

// Search natural entities for representatives
export const USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES = 'USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES';
export const USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES_SUCCESS = 'USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES_SUCCESS';
export const USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES_ERROR = 'USER_MANAGEMENT_SEARCH_NATURAL_ENTITIES_ERROR';

// Create user power (legal entity file)
export const USER_MANAGEMENT_CREATE_USER_POWER = 'USER_MANAGEMENT_CREATE_USER_POWER';
export const USER_MANAGEMENT_CREATE_USER_POWER_SUCCESS = 'USER_MANAGEMENT_CREATE_USER_POWER_SUCCESS';
export const USER_MANAGEMENT_CREATE_USER_POWER_ERROR = 'USER_MANAGEMENT_CREATE_USER_POWER_ERROR';

// Delete user power (legal entity file)
export const USER_MANAGEMENT_DELETE_USER_POWER = 'USER_MANAGEMENT_DELETE_USER_POWER';
export const USER_MANAGEMENT_DELETE_USER_POWER_SUCCESS = 'USER_MANAGEMENT_DELETE_USER_POWER_SUCCESS';
export const USER_MANAGEMENT_DELETE_USER_POWER_ERROR = 'USER_MANAGEMENT_DELETE_USER_POWER_ERROR';

// Replace user power (legal entity file)
export const USER_MANAGEMENT_REPLACE_USER_POWER = 'USER_MANAGEMENT_REPLACE_USER_POWER';
export const USER_MANAGEMENT_REPLACE_USER_POWER_SUCCESS = 'USER_MANAGEMENT_REPLACE_USER_POWER_SUCCESS';
export const USER_MANAGEMENT_REPLACE_USER_POWER_ERROR = 'USER_MANAGEMENT_REPLACE_USER_POWER_ERROR';